import React, { useEffect, useState } from 'react';
import BrowsInDashboard from '../../../Components/Dashboard/TenderDetails/BrowsInDashboard';
import Contact from '../../../Components/Contact/Contact';
import NotPremiumUser from '../../../Components/Dashboard/NotPremiumUser/NotPremiumUser';
import { useLocation } from 'react-router-dom';

const MainDashBoard = () => {
  const location = useLocation();
  const { fromInvoice } = location.state || {};

  console.log('from invoice', fromInvoice);

  // Initialize state with premium_user and user_type
  const [premiumUser, setPremiumUser] = useState(
    fromInvoice
      ? localStorage.getItem('premium_user_i')
      : localStorage.getItem('premium_user')
  );

  const [userType, setUserType] = useState(
    fromInvoice
      ? localStorage.getItem('user_type_i')
      : localStorage.getItem('user_type')
  );

  useEffect(() => {
    setTimeout(() => {
      if (fromInvoice) {
        localStorage.removeItem('premium_user');
        localStorage.removeItem('user_type');

        const newPremiumUser = localStorage.getItem('premium_user_i');
        const newUserType = localStorage.getItem('user_type_i');

        localStorage.setItem('premium_user', newPremiumUser);
        localStorage.setItem('user_type', newUserType);

        setPremiumUser(newPremiumUser);
        setUserType(newUserType);
      } else {
        setPremiumUser(localStorage.getItem('premium_user'));
        setUserType(localStorage.getItem('user_type'));
      }
    }, 500);
  }, [fromInvoice]);

  console.log('userType, premiumUser:', userType, premiumUser);

  return (
    <>
      <div className="container mx-auto">
        {premiumUser === '1' && userType === 'end_user' ? (
          <div className="md:mt-32 mt-28 mb-10">
            <BrowsInDashboard />
          </div>
        ) : (
          <div className="mt-32 mb-10">
            <NotPremiumUser />
          </div>
        )}
      </div>
      <Contact />
    </>
  );
};

export default MainDashBoard;

// import React from 'react';
// import BrowsInDashboard from '../../../Components/Dashboard/TenderDetails/BrowsInDashboard';
// import Contact from '../../../Components/Contact/Contact';
// import NotPremiumUser from '../../../Components/Dashboard/NotPremiumUser/NotPremiumUser';

// const MainDashBoard = () => {
//   const premiumUser =
//     localStorage.getItem('premium_user') ||
//     localStorage.getItem('premium_user_i');

//   const userType =
//     localStorage.getItem('user_type') || localStorage.getItem('user_type_i');

//   console.log('userType, premiumUser:', userType, premiumUser);

//   return (
//     <>
//       <div className="container mx-auto">
//         {premiumUser === '1' && userType === 'end_user' ? (
//           <div className="md:mt-32 mt-28 mb-10">
//             <BrowsInDashboard />
//           </div>
//         ) : (
//           <div className="mt-32 mb-10">
//             <NotPremiumUser />
//           </div>
//         )}
//       </div>
//         <Contact />
//     </>
//   );
// };

// export default MainDashBoard;
